import { render, staticRenderFns } from "./Revision.vue?vue&type=template&id=2951c8ab&"
import script from "./Revision.vue?vue&type=script&lang=js&"
export * from "./Revision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports